// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useGetShipToAndBillTo = () => {
    const billToId = useAppSelector(state => state.context.session.billToId);
    const shipToId = useAppSelector(state => state.context.session.shipToId);
    const shipTo = useAppSelector(state => state.data.shipTos.byId?.[shipToId || ""]);
    const billTo = useAppSelector(state => state.data.billTos.byId?.[billToId || ""]);
    return { billTo, shipTo };
};

export default useGetShipToAndBillTo;
